export const app = Object.freeze({
	sessionCookieName: 'kserv-session',
	deviceDesktopMinWidth: 980
})
